/**
 * OrderStatus
 * --
 */
import { useState, useEffect } from 'react';
import { Content, Title, Row, Col } from 'components';
import { Button, Statistic, Spin } from 'antd';
import { ExportOutlined } from '@ant-design/icons';
import dayjs from 'dayjs'
import MessageAlert, { strCut, stringToMoneyFormat } from 'utils';
import moment from 'moment';
import { useUserStack } from 'store';
const MOMENT_FORMAT = 'YYYY-MM-DD';

/**----------------------------------------
 * [Component] 홈 > 매장별 매출 차트
 * ----------------------------------------
 */
const OrderStatus = ({ loading, data }) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  // console.log('[OrderStatus] data: ', data);
  /* ===== RENDER ===== */
  // JSX: start
  const newData = (key) => {
    //오늘의 현황
    const nowDate = dayjs().format("YYYY-MM-DD");

    if (data[0]?.date === nowDate) {
      return data[0]?.[key];
    }
    return;
    //전체 주문의 현황
    // return data.reduce((acc, cur) => {
    //   acc += Number(cur[option]);
    //   return acc
    // }, 0)
  }
  return (
    <>
      <Spin spinning={loading}>
        <Content
          fullWidth
          padding={0}
          backgroundColor={'none'}
          style={{
            marginBottom: 5,
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          {[
            {
              title: '입금전',
              value: stringToMoneyFormat(newData("depositPendingCount")),
              suffix: '건',
              link: '/order/list/PENDING',
            },
            {
              title: '상품준비중',
              value: stringToMoneyFormat(newData("pendingCount")),
              suffix: '건',
              link: '/shipping/list/PENDING',
            },
            {
              title: '배송준비중',
              value: stringToMoneyFormat(newData("preparingCount")),
              suffix: '건',
              link: '/shipping/list/PREPARING',
            },
            {
              title: '배송보류',
              value: stringToMoneyFormat(newData("onholdCount")),
              suffix: '건',
              link: '/shipping/list/ON_HOLD',
            },
            {
              title: '배송중',
              value: stringToMoneyFormat(newData("shippingCount")),
              suffix: '건',
              link: '/shipping/list/SHIPPING',
            },
            {
              title: '교환신청',
              value: stringToMoneyFormat(newData("exchangeRequestCount")),
              suffix: '건',
              link: '/shipping/list/EXCHANGE_REQUESTED',
            },
            {
              title: '반품신청',
              value: stringToMoneyFormat(newData("returnRequestCount")),
              suffix: '건',
              link: '/shipping/list/RETURN_REQUESTED',
            },
            // {
            //   title: '환불신청',
            //   value: stringToMoneyFormat(Number(data?.refundCount ?? 0)),
            //   suffix: '건',
            //   link: '/shipping/list/RETURN_REQUESTED',
            //   // link: '/order/list?purchase_status=REFUNDED',
            // },
          ].map((_item, _index) => (
            <div
              key={`${_item.label}-${_index}`}
              className="boxShadow"
              style={{
                background: '#FFFFFF',
                borderRadius: 4,
                width: `90%`,
                margin: '0 2px',
                padding: '16px 15px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <Statistic
                className="cursorOverOpacity"
                direction={'row'}
                size="large"
                title={_item.title}
                value={_item.value}
                suffix={_item.suffix}
                // style={{ justifyContent: 'center' }}
                valueStyle={{
                  fontSize: '1.45em',
                  color:
                    _item.value === '0' || _item.value === 0
                      ? '#7f7f7f'
                      : '#1677ff',
                  // textDecoration: 'underline !important',
                }}
              />
              <div>
                <Button
                  shape="circle"
                  onClick={() => window.open(_item.link, '_blank')}
                >
                  <ExportOutlined />
                </Button>
              </div>
            </div>
          ))}
        </Content>
      </Spin>
    </>
  ); // JSX: end
};

OrderStatus.defaultProps = {
  data: null,
};
export default OrderStatus;
